  /*============ public overview Controller
  ================================*/
  angular
    .module('vppApp')
    .controller('publicOverviewController', publicOverviewController);

  publicOverviewController.$inject = ['$scope', '$location', '$stateParams', 'vppConfig', 'ProgramInfoService', 'publicOverviewFactory', 'overviewTableFactory', 'AuthenticationService'];

  function publicOverviewController($scope, $location, $stateParams, vppConfig, ProgramInfoService, publicOverviewFactory, overviewTableFactory, AuthenticationService) {
    var routePath = $location.path().toLowerCase();
    var pCode = routePath.split('/')[2].toUpperCase();
    var isAuth = AuthenticationService.isAuthenticated();
    var program;
    var programCode;
    var programInfo = {
      'programs': []
    };
    var programInf = {};
    var programName;
    if (isAuth) {
      var sPCode = ProgramInfoService.getProgramCode();
    }

    publicOverviewFactory().then(function(response) {

      var programData = response.data;
      programInf['programInfo'] = programData.overviews[pCode];
      programInfo.programs.push(programInf);
      if (sPCode) {
        programCode = sPCode + '-' + pCode;
      } else {
        ProgramInfoService.addProgram(programInfo);
        programCode = programInfo.programs[0].programInfo.code;
        $scope.programId = programInfo.programID;
      }
      //get table for eac programs
      overviewTableFactory(programCode).then(function(response) {
        $scope.tableInfo = response.data.tables;
      });

    });
  };
